<template>
  <div>

    <div class="p-2">

      <el-collapse accordion v-model="activeItem">
        <el-collapse-item
            v-for="level in levels"
            :key="level.key"
            :name="level.key"
            class="mb-4"
        >
          <template slot="title" class="bg-gray-200">
            <h1 class="font-bold">{{ level.name }}</h1>
          </template>

          <main class="bg-gray-200 py-2 px-4 w-full">
            <section class="w-full my-2">
              <!-- Employee Dropdown -->
              <div class="grid grid-cols-2 p-4 gap-5">
                <div class="text-sm mb-4">
                  <label class="block pb-1 font-bold">Select Employee</label>
                  <select
                      class="p-2 bg-white rounded-full w-full"
                      v-model="selectedEmployee"
                      @change="fetchEmployeeQuestions"
                  >
                    <option value="" disabled>Select an Employee</option>
                    <option
                        v-for="employee in employees[level.key]"
                        :key="employee.EmployeeId"
                        :value="employee.EmployeeId"
                    >
                      {{  decryptDataLocal(employee.EmployeeName , decryptionKey)}}
                    </option>
                  </select>
                </div>
              </div>

              <!-- Questions Table -->
              <div v-if="selectedEmployee" class="overflow-x-auto">
                <h3 class="text-lg font-bold mb-4">
                  Questions for: {{ selectedEmployeeName }}
                </h3>
                <table class="w-full table-auto border-collapse border border-gray-300">
                  <thead class="bg-gray-100">
                  <tr>
                    <th class="text-left px-4 py-2 border border-gray-300">
                      Strategic Questions
                    </th>
                    <th
                        v-for="rating in ratings"
                        :key="rating"
                        class="text-center px-4 py-2 border border-gray-300"
                    >
                      {{ rating.label }}
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                      v-for="(question, index) in questions"
                      :key="index"
                      class="border border-gray-300"
                  >
                    <td class="px-4 py-2 border border-gray-300 text-sm">
                      <p class="whitespace-pre-wrap">{{ question.Question }}</p>
                    </td>
                    <td
                        v-for="rating in ratings"
                        :key="rating"
                        class="text-center px-4 py-2 border border-gray-300"
                    >
                      <input
                          type="radio"
                          :name="'question-' + index"
                          :value="rating.value"
                          v-model="answers[index]"
                          class="form-radio text-primary"
                      />
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <!-- Submit Button -->
            <section class="flex gap-2 justify-end my-2">
              <el-button type="warning" @click="submitAnswers">Submit</el-button>
            </section>
          </main>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {mapGetters} from "vuex";
import decryptData from "@/utils/decrypt";

export default {
  name: "360dGoals",
  computed:{
    ...mapGetters(["getOrganization", "getToken"]),

  },
  created() {
    this.get360Questions()
    this.fetchEmployees()
    this.decryptDataLocal = decryptData;
    this.decryptionKey = this.$decryptionKey;
    this.getPerformancePeriods()
  },
  data() {
    return {
      activeItem: '',
       levels:[
         {
           name:"Higher Level",
           key:"HighLevelEmployees"
         },
         {
           name: "Same Level",
           key:"SameLevelEmployees"
         },
         {
           name:"Lower Level",
           key:"LowLevelEmployees"
         }
       ],
      questions:[],
      ratings: [
        { value: 5, label: "Strongly Agree" },
        { value: 4, label: "Agree" },
        { value: 3, label: "Neutral" },
        { value: 2, label: "Disagree" },
        { value: 1, label: "Strongly Disagree" },
      ],
      answers: {},
      selectedEmployee: "",
      employees: [],
      selectedEmployeeName: "",
      decryptionKey: '',
      decryptDataLocal: '',
      ReviewPeriodIds: [],
    };
  },
  methods:{
    getPerformancePeriods() {
      this.loading = true;
      let url = `${this.getOrganization}/performance/period/${this.$ApiVersion}/request`;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              console.log(response.data.Data);
              this.ReviewPeriodIds = response.data.Data;
            } else {
              this.$notify.error({
                title: "Failure",
                message: response.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;
            this.$notify.error({ title: "Failure", message: error.message });
          }
      );
    },
    submitAnswers() {
      if (!this.selectedEmployee) {
        this.$message.error("Please select an employee.");
        return;
      }
      const payload = {
        Feedbacks: this.questions.map((question, index) => ({
          PeriodId: this.ReviewPeriodIds[0].Id,
          ReceiverId: this.selectedEmployee,
          QuestionId: question.Id,
          FeedbackContent: "Feedback",
          Rating: this.answers[index],
          FeedbackRequestId: question.FeedbackRequestId || null,
        })),
      };
      const unanswered = payload.Feedbacks.some((item) => !item.Rating);
      if (unanswered) {
        this.$message.error("Please answer all questions before submitting.");
        return;
      }
      let url = `${this.getOrganization}/performance/360evaluation/feedback/${this.$ApiVersion}/create`;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
          .post(url, payload, options)
          .then((response) => {
            console.log(response.data)
            if (response.data.StatusCode == 200){
              this.$message.success("Feedback submitted successfully!");
              this.resetForm();
            } else {
              this.$message.error(response.data.StatusMessage);
            }
          })
          .catch((error) => {
            this.$message.error(
                "Failed to submit feedback. Please try again later."
            );
            console.error(error);
          });
    },

    resetForm() {
      this.selectedEmployee = null;
      this.answers = [];
      this.selectedEmployeeName = "";
    },
    get360Questions() {
      this.loading = true;
      let url = `${this.getOrganization}/performance/360evaluation/question/${this.$ApiVersion}/request`;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
          (response) => {
            this.loading = false;
            console.log(response.data)
            if (response.data.StatusCode == 200) {
              this.questions = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
      );
    },
    fetchEmployeeQuestions() {
      const employee = this.employees.find((emp) => emp.id === this.selectedEmployee);
      this.selectedEmployeeName = employee ? employee.name : "";
      //Reset the answers when the user selects a new employee
      this.answers={}
    },
    fetchEmployees(){
      this.loading = true;
      let url = `${this.getOrganization}/performance/360evaluation/employee/hierarchy/${this.$ApiVersion}/request`;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
          (response) => {
            this.loading = false;
            console.log(response.data)
            if (response.data.StatusCode == 200) {
              this.employees=response.data.Data
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
      );
    }
  },
};
</script>
